import React from 'react';
import styles from './AnalyticsReportTable.module.scss';
import { AnalyticsOverviewResponse } from '../../../../types/adminAnalytics.ts';
import { formatDeltaPercent, formatDeltaValue, trendLabel } from '../../../../utils/adminAnalyticsHelpers.ts';

interface AnalyticsReportTableProps {
  report: AnalyticsOverviewResponse['report'];
}

const AnalyticsReportTable: React.FC<AnalyticsReportTableProps> = ({ report }) => {
  if (!report.rows.length) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>Detalle del informe</h3>
      <div className={styles.tableScroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Sección</th>
              <th>Métrica</th>
              <th>Actual</th>
              <th>Anterior</th>
              <th>Delta</th>
              <th>%</th>
              <th>Tendencia</th>
            </tr>
          </thead>
          <tbody>
            {report.rows.map((row) => (
              <tr key={`${row.section}-${row.metricKey}`}>
                <td>{row.sectionLabel}</td>
                <td>{row.metricLabel}</td>
                <td>{row.current.toLocaleString('es-AR')}</td>
                <td>{row.previous.toLocaleString('es-AR')}</td>
                <td>{formatDeltaValue(row.delta)}</td>
                <td>{formatDeltaPercent(row.deltaPercent)}</td>
                <td>
                  <span
                    className={`${styles.trend} ${styles[`trend_${row.trend}`] ?? ''}`}
                  >
                    {trendLabel(row.trend)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AnalyticsReportTable;
